module.exports = __webpack_public_path__ + "catalog/items/bathroom/corner-sink/corner-sink.svg";